import * as THREE from "three";

export enum Jaw {
  Upper = "upper",
  Lower = "lower",
}

// Self-aware tooth mesh
interface Tooth extends THREE.Mesh {
  toothId: number; // e.g., 12 or "B"
  jaw: Jaw;
  stepIndex: number;
}

// Self-aware gum group
interface GumGroup extends THREE.Group {
  jaw: Jaw;
  teeth: Tooth[];
  stepIndex: number;
}

// Self-aware step group
interface StepGroup extends THREE.Group {
  stepIndex: number;
  gums: Partial<Record<"upper" | "lower", GumGroup>>;
}

// Self-aware case group
interface CaseGroup extends THREE.Group {
  caseId: string;
  steps: StepGroup[];
}
